import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import AllProducts from 'src/views/products/AllProducts';
import AddProduct from 'src/views/products/AddProduct';
import AllBanners from 'src/views/Banners/AllBanners';
import AllUsers from 'src/views/Users/AllUsers';
import AllOrders from 'src/views/Orders/AllOrders';
import AddCategory from 'src/views/products/AddCategory';
import EditProduct from 'src/views/products/EditProduct';
import AllCategory from 'src/views/products/AllCategory';
import AddBillings from 'src/views/Billings/AddBillings';
import AddAppointment from 'src/views/Appointments/AddAppointment';
import AddStaff from 'src/views/staffs/AddStaff';
import AddService from 'src/views/Services/AddService';
import AddClient from 'src/views/clients/AddClient';
import AddMembership from 'src/views/Membership/AddMembership';
import AllAppointments from 'src/views/Appointments/AllAppointments';
import AllClients from 'src/views/clients/AllClients';
import AllStaffs from 'src/views/staffs/AllStaffs';
import AllBillings from 'src/views/Billings/AllBillings';
import AllServices from 'src/views/Services/AllServices';
import AllMembers from 'src/views/Membership/AllMembers';
import AllBranch from 'src/views/Branch/AllBranch';
import AddBranch from 'src/views/Branch/AddBranch';
import AllFeedbacks from 'src/views/Feedbacks/AllFeedbacks';
import AddFeedback from 'src/views/Feedbacks/AddFeedback';
import AllRequests from 'src/views/Requests/AllRequests';
import Appointment from 'src/views/managestaff/Appointment';
import Attendance from 'src/views/managestaff/Attendance';
import SalaryAndIncentive from 'src/views/managestaff/SalaryAndIncentive';
import Leave from 'src/views/managestaff/Leave';


/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const Dashboard = Loadable(lazy(() => import('../views/dashboard/Dashboard')))
const SamplePage = Loadable(lazy(() => import('../views/sample-page/SamplePage')))
const Icons = Loadable(lazy(() => import('../views/icons/Icons')))
const TypographyPage = Loadable(lazy(() => import('../views/utilities/TypographyPage')))
const Shadow = Loadable(lazy(() => import('../views/utilities/Shadow')))
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Register = Loadable(lazy(() => import('../views/authentication/Register')));
const Login = Loadable(lazy(() => import('../views/authentication/Login')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/ForgotPassword')));

const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', element: <Navigate to="/attendance" /> },
      { path: '/dashboard', exact: true, element: <Dashboard /> },
      { path: '/appointments', exact: true, element: <AllAppointments /> },
      { path: '/addappointment', exact: true, element: <AddAppointment /> },
      { path: '/feedbacks', exact: true, element: <AllFeedbacks /> },
      { path: '/addfeedback', exact: true, element: <AddFeedback /> },
      { path: '/requests', exact: true, element: <AllRequests /> },
      { path: '/branches', exact: true, element: <AllBranch /> },
      { path: '/addbranch', exact: true, element: <AddBranch /> },
      { path: '/billings', exact: true, element: <AllBillings /> },
      { path: '/addbilling', exact: true, element: <AddBillings /> },
      { path: '/staffs', exact: true, element: <AllStaffs /> },
      { path: '/addstaff', exact: true, element: <AddStaff /> },
      { path: '/services', exact: true, element: <AllServices /> },
      { path: '/addservice', exact: true, element: <AddService /> },
      { path: '/clients', exact: true, element: <AllClients /> },
      { path: '/addclient', exact: true, element: <AddClient /> },
      { path: '/memberships', exact: true, element: <AllMembers /> },
      { path: '/addmembership', exact: true, element: <AddMembership /> },
      { path: '/sample-page', exact: true, element: <SamplePage /> },
      { path: '/icons', exact: true, element: <Icons /> },
      { path: '/products', exact: true, element: <AllProducts /> },
      { path: '/addproduct', exact: true, element: <AddProduct /> },
      { path: '/editproduct/:id', exact: true, element: <EditProduct /> },
      { path: '/categories', exact: true, element: <AllCategory /> },
      { path: '/addcategory', exact: true, element: <AddCategory /> },
      { path: '/banners', exact: true, element: <AllBanners /> },
      { path: '/orders', exact: true, element: <AllOrders /> },
      { path: '/users', exact: true, element: <AllUsers /> },
      { path: '/appointment', exact: true, element: <Appointment /> },
      { path: '/attendance', exact: true, element: <Attendance /> },
      { path: '/salary', exact: true, element: <SalaryAndIncentive /> },
      { path: '/ui/typography', exact: true, element: <TypographyPage /> },
      { path: '/ui/shadow', exact: true, element: <Shadow /> },
      { path: '/leave', exact: true , element: <Leave/>},
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '/auth/register', element: <Register /> },
      { path: '/auth/login', element: <Login /> },
      { path: '/auth/forgotpassword', element: <ForgotPassword /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
